<template>
    <v-dialog v-model="dialog"
              @click:outside="closeDialog"
              max-width="600px"
              scrollable
    >
        <v-card>
            <v-toolbar dense :elevation="0">
                <v-toolbar-title class="text-primary-700">
                    Merge Companies
                </v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-btn icon @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
			<v-divider></v-divider>
            <v-card-text class="pt-4">
                <v-row class="mt-0">
                    <v-col cols="12">
                        <v-autocomplete
                                v-model="form.to_company_id"
                                :loading="toCompanies.loading"
                                :items="toCompanies.items"
                                :search-input.sync="toCompanies.search"
                                cache-items
                                flat
								outlined
								dense
                                hide-no-data
                                clearable
                                item-text="name"
                                item-value="id"
                                label="Original company (the company the data is added to)"
                                v-validate="'required'"
                                :error-messages="errors.collect('form.to_company_id')"
                                data-vv-name="form.to_company_id"
                                data-vv-as="Original Company"
                                required
                        ></v-autocomplete>

                        <v-autocomplete
                                v-model="form.companies_for_merge"
                                :loading="companiesForMerge.loading"
                                :items="companiesForMerge.items"
                                :search-input.sync="companiesForMerge.search"
                                cache-items
                                flat
								outlined dense
                                multiple
                                hide-no-data
                                clearable
                                small-chips
                                return-object
                                item-text="name"
                                item-value="id"
                                label="Companies For Merge"
                                v-validate="'required'"
                                :error-messages="errors.collect('form.companies_for_merge')"
                                data-vv-name="form.companies_for_merge"
                                data-vv-as="Companies For Merge"
                                required
                        ></v-autocomplete>
						<v-divider class="mb-2"></v-divider>
                        <v-checkbox hide-details v-model="form.transfer_users">
                            <template v-slot:label>
                                <div>
                                    Merge Contacts?
                                    <v-chip class="ml-2" label small>Users: {{contactsCount}}</v-chip>
                                </div>
                            </template>
                        </v-checkbox>
                        <v-checkbox hide-details v-model="form.transfer_properties">
                            <template v-slot:label>
                                <div>
                                    Merge Properties?
                                    <v-chip class="ml-2" label small>Tenants: {{propertiesCount}}</v-chip>
                                </div>
                            </template>
                        </v-checkbox>
                        <v-checkbox hide-details v-model="form.transfer_schemes">
                            <template v-slot:label>
                                <div>
                                    Merge Schemes?
                                    <v-chip class="ml-2 mr-2" label small >Landlords: {{landlordSchemesCount}}</v-chip>
                                    <v-chip label small>Landlord Agents: {{landlordAgentSchemesCount}}</v-chip>
                                </div>
                            </template>
                        </v-checkbox>
						<v-checkbox hide-details v-model="form.transfer_enquiries">
							<template v-slot:label>
								<span>Transfer Enquiries?</span>
								<v-chip class="ml-2" label small>Enquiries: {{enquiriesCount}}</v-chip>
							</template>
						</v-checkbox>
						<v-checkbox hide-details v-model="form.transfer_deals">
							<template v-slot:label>
								<span>Transfer Deals?</span>
								<v-chip class="ml-2" label small>Deals: {{dealsCount}}</v-chip>
							</template>
						</v-checkbox>
						<v-checkbox hide-details v-model="form.transfer_pipelines">
							<template v-slot:label>
								<span>Transfer Pipelines?</span>
								<v-chip class="ml-2" label small>Pipelines: {{pipelinesCount}}</v-chip>
							</template>
						</v-checkbox>
                        <v-checkbox
                                v-model="form.remove_merged"
                                label="Remove merged companies?"
                        >
                            <template v-slot:label>
                                <span class="red--text">Remove merged companies?</span>
                            </template>
                        </v-checkbox>
                    </v-col>
                </v-row>

            </v-card-text>
			<v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outlined @click="closeDialog">Cancel</v-btn>
                <v-btn depressed :disabled="!!errors.items.length || !formValidated" color="primary" @click="save">Merge</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
	export default {
		name: "mergeCompaniesDialog",
		data: () => ({
			dialog: false,
			form: {
				to_company_id: null,
				companies_for_merge: [],
				transfer_users: false,
				transfer_properties: false,
				transfer_schemes: false,
				transfer_enquiries: false,
				transfer_deals: false,
				transfer_pipelines: false,
				remove_merged: false,
			},
			toCompanies: {
				loading: false,
				items: [],
				search: null,
			},
			companiesForMerge: {
				loading: false,
				items: [],
				search: null,
			},
		}),
		computed: {
			formValidated() {
				return Object.keys(this.fields).some(key => this.fields[key].validated)
					&& Object.keys(this.fields).some(key => this.fields[key].valid);
			},
            contactsCount() {
				return _.sumBy(this.form.companies_for_merge, 'users_count');
            },
			propertiesCount() {
				return _.sumBy(this.form.companies_for_merge, 'properties_count');
			},
			landlordSchemesCount() {
				return _.sumBy(this.form.companies_for_merge, 'landlord_schemes_count');
			},
			landlordAgentSchemesCount() {
				return _.sumBy(this.form.companies_for_merge, 'landlord_agent_schemes_count');
			},
			enquiriesCount() {
				return _.sumBy(this.form.companies_for_merge, 'enquiries_count');
			},
			dealsCount() {
				return _.sumBy(this.form.companies_for_merge, 'deals_count');
			},
			pipelinesCount() {
				return _.sumBy(this.form.companies_for_merge, 'pipelines_count');
			},
		},
		watch: {
			'toCompanies.search'() {
				this.getToCompanies();
			},
			'companiesForMerge.search'() {
				this.getCompaniesForMerge();
			},
		},
		methods: {
			async getToCompanies () {
				const response = await this.$http.get('/companies/', {
					params: {
						q: this.toCompanies.search,
						per_page: 100,
					}
				});
				this.toCompanies.items = response.data.data;
			},
			async getCompaniesForMerge () {
				const response = await this.$http.get('/companies/', {
					params: {
						include: 'deals_count',
						q: this.companiesForMerge.search,
						per_page: 100,
					}
				});
				this.companiesForMerge.items = response.data.data;
			},
			async getCompany(id) {
				const {data} = await this.$http.get(`/companies/${id}`, {
				});
				this.form.to_company_id = data.id;
				this.toCompanies.items.push(data);
			},
			showDialog: function (companyId) {
				this.dialog = true;
				if(companyId) {
					this.getCompany(companyId);
                    this.$notify.warn('Merging is not recorded in the company history')
                }
			},
			closeDialog: function () {
				this.dialog = false;
				this.clearForm();
				this.$emit('closed');
			},
			prepareFormData() {
				let form = Object.assign({}, this.form)
				form.companies_for_merge = this.form.companies_for_merge.map((item) => {return item.id})
				return form;
			},
			async save() {
				if (await this.$formValidator.validate(this.form)) {
					try {
						await this.$http.post('/companies/merge', this.prepareFormData())
						this.$emit('saved');
						this.closeDialog();
					} catch (e) {
						this.$validationException(e)
					}
				}
			},
			clearForm () {
				this.form = {
					to_company_id: null,
					companies_for_merge: [],
					transfer_users: false,
					transfer_properties: false,
					transfer_schemes: false,
					remove_merged: false,
				};
				this.$validator.reset();
			}
		},

	}
</script>

<style scoped>

</style>
